import {
  Row,
  Col,
  message,
  Typography,
  Tag,
  Button,
  InputNumber,
} from 'kenshin';
import {
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState,
  useEffect,
} from 'react';
import ModifyCountModal from './ModifyCountModal';
import QuantityInputWrapper from './QuantityInputWrapper';
import { connect, history } from 'umi';
import ItemDetail from './itemDetail';
import ModalFormPro from '../ModalFormPro';
import './index.less';
import { useDrag, useMemoizedFn } from 'ahooks';
import { timeDiff } from '../../_util';
import { ServContext } from '../../pages/project/list/AddProject';
import { debounce, flat } from '@/_util';
import SortBox from './SortBox';
import { render } from 'react-dom';
import TablePro from '@/components/TablePro';

let idCacheMap = new Map();
// 调试缓存
let cacheNum = 0;
let baseNum = 0;
// 树遍历查找
export const findTree = (fildTree = [], id) => {
  if (id == null || id == undefined || fildTree.length == 0) {
    return undefined;
  }
  let hasH = /-/.test(id);
  let cacheId = hasH ? id.split('-')[1] : id;
  // 缓存机制，多次调用查找树，存在缓存中则取缓存
  if (idCacheMap.get(cacheId)) {
    // cacheNum++;
    // console.log(idCacheMap);
    // console.log('执行函数次数', baseNum);
    // console.log('取缓存数据次数', cacheNum);
    return idCacheMap.get(cacheId);
  }
  let resData = flat(
    fildTree.map((item) => item.options),
    2,
  ).find((item) => {
    if (!hasH && item.value?.split('-')[1] == id) {
      return true;
    }
    if (hasH && item.value == id) {
      return true;
    }
  });
  // baseNum++;
  idCacheMap.set(cacheId, resData);
  return resData;
};

function deepChangeList(tree, parent = null) {
  return tree.map((item) => {
    if (parent && parent.childList) {
      let count = parent.childList.reduce(
        (pre, cur) => pre + cur.servCatgCount,
        0,
      );
      item.maxCount = parent.servCatgCount - count + item.servCatgCount;
    }
    if (item.childList) {
      item.childList = deepChangeList(item.childList, item);
    }
    return item;
  });
}

// 查自己添加的服务类目对应树节点
export const dataListFind = (list, key, findParent = false, parent = null) => {
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    if (item.key == key) {
      if (findParent) return parent;
      return item;
    }
    if (item.childList) {
      let findItem = dataListFind(item.childList, key, findParent, item);
      if (findItem) return findItem;
    }
  }
};

// 服务类目金额计算公式
export const getPrice = (data, pirceChange) => {
  /*

    单价、总优惠金额不需要传给后端，前端展示用，

    servCatgTotalDisc：总价折扣率需要处理后传给后端
    总价折扣率 = 总价 / 优惠后的总价

  */
  const {
    servCatgCount, // 数量
    servCatgHourOrginCost, // 工时费
    servCatgOrginTotalAmount, // 总价
    servCatgDiscTotalAmount, // 优惠后总价
  } = data;

  let servCatgWorkPeriod = 0, // 工时数
    servCatgUnitPrice = 0, // 单价
    servCatgHourDiscCost = 0, // 优惠后单价
    servCatgHourDisc = 0, // 优惠折扣
    DiscountAmount = 0; // 总优惠金额
  // 单价 = 总价 / 数量
  if (servCatgOrginTotalAmount && servCatgCount) {
    servCatgUnitPrice = +(servCatgOrginTotalAmount / servCatgCount).toFixed(2);
  }
  // 优惠后单价 = 优惠后总价 / 数量
  if (servCatgDiscTotalAmount && servCatgCount) {
    servCatgHourDiscCost = +(servCatgDiscTotalAmount / servCatgCount).toFixed(
      2,
    );
    pirceChange?.(servCatgHourDiscCost);
  }
  // 工时数 = 单价 / 工时费
  if (servCatgUnitPrice && servCatgHourOrginCost) {
    servCatgWorkPeriod = +(servCatgUnitPrice / servCatgHourOrginCost).toFixed(
      2,
    );
  }
  // 优惠折扣 = 优惠后总价 / 总价
  if (+servCatgDiscTotalAmount && +servCatgOrginTotalAmount) {
    servCatgHourDisc = +(
      servCatgDiscTotalAmount / servCatgOrginTotalAmount
    ).toFixed(2);
  }
  // 总优惠金额 = 总价 - 优惠后总价
  if (servCatgOrginTotalAmount && servCatgDiscTotalAmount) {
    DiscountAmount = +(
      servCatgOrginTotalAmount - servCatgDiscTotalAmount
    ).toFixed(2);
  }

  return {
    servCatgWorkPeriod,
    servCatgUnitPrice,
    servCatgHourDiscCost,
    servCatgHourDisc,
    DiscountAmount,
  };
};

const statusObj = {
  0: '未完成',
  1: '已完成',
  2: '删除',
};

export const sortToArrData = (baseArr, prefix) => {
  if (!Array.isArray(baseArr)) return [];
  let resArr = [];
  baseArr.map((item, index) => {
    let servCatgCode = [prefix, index + 1]
      .filter((item) => item != undefined)
      .join('.');

    if (item.servCatgCode != servCatgCode) {
      // 只需要改变过的
      resArr.push({
        proServCatgId: item.proServCatgId,
        sort: index,
        // name: item.servCatgName,
        servCatgCode,
      });
    }
    if (item.childList) {
      let childArr = sortToArrData(item.childList, servCatgCode);
      resArr = [...resArr, ...childArr];
    }
  });
  return resArr;
};

let TeamMemberListOldArr = [];
//设置参与团队，已经选择
let TeamMemberListArr = [];

const ServCategoryList = ({
  systemOrgani,
  dispatch,
  project,
  value,
  onChange,
  // 关闭编辑等按钮
  disabled,
  // 顶部扩展，放在按钮后面
  headerExtra,
  extra,
  pirceChange,
  onDelete,
  onSort,
  onSave,
  loading,
  rowData, // 列表数据
  isSplitProworkPkg = false, //是否拆分包
}) => {
  const modalRef = useRef();
  // const { setDeleteList } = useContext(ServContext);
  const [dataList, setDataList] = useState([]);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editModalData, setEditModalData] = useState(null);
  const [leaderKey, setLeaderKey] = useState('');
  const [isSplitProworkPkgModal, setIsSplitProworkPkgModal] = useState(false); //是否为拆分弹窗
  const [isCheckSplitProworkPkgModal, setIsCheckSplitProworkPkgModal] =
    useState(false); //是否为查看拆分后的子包弹窗
  const [selectKey, setSelectKey] = useState([]);
  const [selectedSplitType, setselectedSplitType] = useState('');
  const [oldServCatgCount, setOldServCatgCount] = useState(0);
  const [countModalVisible, setCountModalVisible] = useState(false);

  const isAddStatus = useRef(false);

  const handleCountModalOk = (totalCount, subList) => {
    let minNum = editModalData.servCatgFinishNum;
    if (totalCount < minNum) {
      message.error(`数量不能小于已完成数量${minNum}`);
      return;
    }
    const { form } = modalRef.current;
    form.setFieldsValue({
      servCatgCount: totalCount,
      subProServCatgCountList: subList,
    });
    conutChange(totalCount, 'servCatgCount');
    setCountModalVisible(false);
  };

  console.log('editModalData', editModalData);

  useEffect(() => {
    console.log('systemOrgani.employeeAll...', systemOrgani.employeeAll);
  }, [systemOrgani.employeeAll]);

  useEffect(() => {
    if (
      Array.isArray(value) &&
      systemOrgani.employeeAll
      // dataList.length == 0
    ) {
      let newList = deepChangeList([...JSON.parse(JSON.stringify(value))]);
      console.log('value123', newList);

      setDataList(newList);
      setTeamMemberListData();
    }
  }, [value, systemOrgani.employeeAll]);

  useEffect(() => {
    //设置参与团队，已经选择
    setTeamMemberListData();
    // TeamMemberListArr = [];
    // if (rowData.proPreallocationMemberList) {
    //   console.log('TeamMemberListArr,首次', TeamMemberListArr);
    //   rowData.proPreallocationMemberList.map((item) => {
    //     systemOrgani.employeeAll.map((employee) => {
    //       employee.options.map((o) => {
    //         if (item && item.teamMemberId == o.value.split('-')[1]) {
    //           TeamMemberListArr.push(o);
    //         }
    //       });
    //     });
    //   });
    //   console.log('TeamMemberListArr,首次1', TeamMemberListArr);
    //   // 去重
    //   TeamMemberListArr =  Array.from(new Set(TeamMemberListArr.map(a => JSON.stringify(a)))).map(str => JSON.parse(str));
    //   console.log('TeamMemberListArr,首次去重', TeamMemberListArr);
    //   TeamMemberListOldArr = TeamMemberListArr;
    // }
  }, []);

  useEffect(() => {
    const { form } = modalRef.current;

    //已完成工作包
    let completeCount = form.getFieldValue('servCatgFinishNum');
    //未完成工作包
    let incompleteCount = oldServCatgCount - completeCount;

    console.log(
      'selectedSplitType',
      '未完成' + incompleteCount,
      '已完成' + completeCount,
      '原始' + oldServCatgCount,
    );

    form.setFieldsValue({
      servCatgCount:
        selectedSplitType == 1
          ? completeCount > oldServCatgCount
            ? oldServCatgCount
            : completeCount //已完成
          : incompleteCount >= 0
          ? incompleteCount
          : oldServCatgCount, //未完成
    });
  }, [selectedSplitType]);

  const setTeamMemberListData = () => {
    //设置参与团队，已经选择
    TeamMemberListArr = [];
    if (rowData.proPreallocationMemberList) {
      console.log('TeamMemberListArr,首次', TeamMemberListArr);
      rowData.proPreallocationMemberList.map((item) => {
        systemOrgani.employeeAll.map((employee) => {
          employee.options.map((o) => {
            if (item && item.teamMemberId == o.value.split('-')[1]) {
              TeamMemberListArr.push(o);
            }
          });
        });
      });
      console.log('TeamMemberListArr,首次1', TeamMemberListArr);
      // 去重
      TeamMemberListArr = Array.from(
        new Set(TeamMemberListArr.map((a) => JSON.stringify(a))),
      ).map((str) => JSON.parse(str));
      console.log('TeamMemberListArr,首次去重', TeamMemberListArr);
      TeamMemberListOldArr = TeamMemberListArr;
    }
  };

  const addItem = () => {
    console.log('rowData =', rowData);
    console.log('TeamMemberListArr,addItem', TeamMemberListArr);
    setIsSplitProworkPkgModal(false);
    setEditModalVisible(true);
    const { form } = modalRef.current;
    form.setFieldsValue({ servCatgHourOrginCost: 1800 });
    form.setFieldsValue({ addTeamMemberList: TeamMemberListArr });
    TeamMemberListOldArr = TeamMemberListArr;
    console.log('TeamMemberListArr,addItem1', TeamMemberListOldArr);
  };

  // 服务类目编辑或新增完成
  const editChange = async (val) => {
    if (isAddStatus.current) {
      return addChange(val);
    }
    // 子级新增
    // console.log("编辑",editModalData,val);
    // if(!editModalData || editModalData?.$childrenAdd){
    //   if(val.servCatgDiscTotalAmount > residueMoney){
    //     message.error("")
    //     return ;
    //   }
    // }

    // console.log(11111)

    // //新增项目预分配成员列表，如果对比旧成员有新增
    // addpropreallocationmemberdata(val.addTeamMemberList, TeamMemberListOldArr);

    // console.log(11112)
    if (editModalData?.$childrenAdd) {
      editModalData.childList = editModalData.childList || [];
      let curData = dataListFind(dataList, editModalData.key);
      let otherData = {
        proServCatgPantId: curData.proServCatgId,
        servCatgCode: `${curData.servCatgCode}.${
          (curData.childList?.length || 0) + 1
        }`,
        servCatgSort: (curData.childList?.length || 0) + 1,
        dbServCatgList: curData.dbServCatgList,
      };
      let data = {
        key: +new Date(),
        ...val,
        childrenAdd: true,
      };

      data.taskIdList = selectKey;

      console.log('拆分接口。。。', val, curData, editModalData);

      if (editModalData && data.servCatgCount >= editModalData?.servCatgCount) {
        message.warning('拆分数量不能大于工作包数量！');
        return;
      }

      if (data?.splitType == 0) {
        //拆分未完成的工作包
        if (
          editModalData &&
          data.servCatgCount >=
            editModalData?.servCatgCount - editModalData?.servCatgFinishNum
        ) {
          message.warning('拆分数量不能大于未完成工作包数量！');
          return;
        }
      } else if (data?.splitType == 1) {
        //拆分未完成的工作包
        if (
          editModalData &&
          data.servCatgCount > editModalData?.servCatgFinishNum
        ) {
          message.warning('拆分数量不能大于已完成工作包数量！');
          return;
        }
      }

      // return

      let success = await onSave?.(data, otherData);
      if (success) {
        setEditModalData(null);
        setEditModalVisible(false);
      }

      return;
    }

    //新增项目预分配成员列表，如果对比旧成员有新增
    addpropreallocationmemberdata(val.addTeamMemberList, TeamMemberListOldArr);

    let data = {
      key: +new Date(),
      $top: true,
    };
    Object.keys(val).map((item) => {
      data[item] = val[item];
      if (val[item] == undefined) {
        data[item] = null;
      }
    });
    if (
      editModalData &&
      data.servCatgCount < editModalData?.servCatgFinishNum
    ) {
      message.warning('数量不能小于已关闭的的数量！');
      return;
    }
    console.log(11115, data);
    // console.log('编辑', data, editModalData);
    let success = await onSave?.(
      data,
      editModalData || {
        servCatgCode: dataList.length + 1,
        servCatgSort: dataList.length + 1,
      },
    );
    if (success) {
      // console.log(11116)
      setTimeout(() => {
        setEditModalData(null);
        setEditModalVisible(false);
      }, 500);

      message.success('更新成功！');
      // console.log(11117)
    }
  };

  // 服务类目编辑或新增完成
  const addChange = async (val) => {
    //新增项目预分配成员列表，如果对比旧成员有新增
    addpropreallocationmemberdata(val.addTeamMemberList, TeamMemberListOldArr);

    if (editModalData?.$childrenAdd) {
      editModalData.childList = editModalData.childList || [];
      let curData = dataListFind(dataList, editModalData.key);
      let otherData = {
        proServCatgPantId: curData.proServCatgId,
        servCatgCode: `${curData.servCatgCode}.${
          (curData.childList?.length || 0) + 1
        }`,
        servCatgSort: (curData.childList?.length || 0) + 1,
      };
      let data = {
        key: +new Date(),
        ...val,
      };
      // console.log(11113)
      let success = await onSave?.(data, otherData);
      if (success) {
        setEditModalData(null);
        setEditModalVisible(false);
        // console.log(11114)
      }
      return;
    }
    let data = {
      key: +new Date(),
      $top: true,
    };
    Object.keys(val).map((item) => {
      data[item] = val[item] || null;
    });
    if (
      editModalData &&
      data.servCatgCount < editModalData?.servCatgFinishNum
    ) {
      message.warning('数量不能小于已关闭的的数量！');
      return;
    }
    console.log(11115);
    // console.log('编辑', data, editModalData);
    let success = await onSave?.(
      data,
      editModalData || {
        servCatgCode: dataList.length + 1,
        servCatgSort: dataList.length + 1,
      },
    );
    if (success) {
      // console.log(11116)
      setTimeout(() => {
        setEditModalData(null);
        setEditModalVisible(false);
      }, 500);

      message.success('更新成功！');
      // console.log(11117)
    }
  };

  // 服务类目更改后自动填入数据
  const setFormValueChange = (id) => {
    const { form } = modalRef.current;
    dispatch({
      type: 'project/getServcatgDetailList',
      payload: {
        serviceCategoryId: id,
      },
    }).then((res) => {
      // 自动填充
      form.setFieldsValue({ ...res, servCatgTime: null });
    });
  };

  //新增项目预分配成员列表，如果对比旧成员有新增
  const addpropreallocationmemberdata = (newarr, oldarr) => {
    newarr = newarr.map((item) => {
      if (typeof item === 'object') {
        return item.value;
      } else {
        return item;
      }
    });

    oldarr = oldarr.map((item) => {
      if (typeof item === 'object') {
        return item.value;
      } else {
        return item;
      }
    });

    console.log('addpropreallocationmemberdata...', newarr, oldarr);
    // var filteredArr = [...newarr, ...oldarr.map((item) => item.value)];
    // = newarr.filter(
    //   (item1) => !oldarr.find((item2) => item2.value === item1),
    // );

    if (newarr == undefined || newarr.length == 0) {
      return;
    }

    // if(typeof oldarr[0] === "object"){
    //     // 将oldarr中的元素转换为字符串形式
    //     const oldarrString = oldarr.map(obj => JSON.stringify(obj));

    //     // 找出newarr中在oldarr中不存在的元素
    //     const increment = newarr.filter(obj => !oldarrString.includes(JSON.stringify(obj)));

    //     newarr = Array.from(new Set(increment));
    //     console.log("newarr 1 = ",newarr);
    //     if(newarr.length == 0){
    //       return
    //     }
    // }else{
    //   const oldarrString = new Set(oldarr);
    //   const incrementObjects = newarr.filter(obj => !oldarrString.has(obj));
    //   newarr = Array.from(new Set(incrementObjects));
    //   console.log("newarr 2 = ",newarr);

    //   if(newarr.length == 0){
    //     return
    //   }
    // }

    newarr = [...new Set([...newarr, ...oldarr])];

    console.log('filteredArr = ', newarr);
    let projectId = history.location.query?.projectId;
    dispatch({
      type: 'project/addProprealLocationMemberData',
      payload: newarr?.map((item, index) => {
        // console.log('addpropreallocationmemberdata...item', item.value.split("-"));
        return {
          projectId: projectId,
          teamMemberId: item.value
            ? item.value.split('-')[1]
            : item.split('-')[1],
          teamMemberSort: index + 1,
        };
      }),
    }).then((res) => {
      TeamMemberListArr = [];
      newarr.map((item) => {
        systemOrgani.employeeAll.map((employee) => {
          employee.options.map((o) => {
            if (item && item == o.value) {
              TeamMemberListArr.push(o);
            }
          });
        });
      });
      // console.log("addpropreallocationmemberdata...TeamMemberListArr",TeamMemberListArr);
    });
  };

  // 修改数量、单价、优惠后单价后计算总价、优惠后总价
  const setPriceAll = (form) => {
    // 检查优惠后总价是否禁用
    const isDiscTotalAmountDisabled =
      (!!editModalData && !editModalData?.$childrenAdd) ||
      editModalData?.$childrenAdd ||
      isSplitProworkPkgModal;

    if (isDiscTotalAmountDisabled || editModalData?.$childrenAdd) {
      const servCatgUnitPrice = form.getFieldValue('servCatgUnitPrice'); // 单价
      const servCatgHourDiscCost = form.getFieldValue('servCatgHourDiscCost'); // 优惠后单价
      let servCatgCount = form.getFieldValue('servCatgCount'); // 数量
      if (
        servCatgCount != null &&
        servCatgUnitPrice != null &&
        servCatgHourDiscCost != null
      ) {
        const servCatgOrginTotalAmount = +(
          servCatgCount * servCatgUnitPrice
        ).toFixed(2);
        const servCatgDiscTotalAmount = +(
          servCatgCount * servCatgHourDiscCost
        ).toFixed(2);

        form.setFieldsValue({
          servCatgOrginTotalAmount,
          servCatgDiscTotalAmount,
          // 重新计算其他价格相关字段
          ...getPrice(
            {
              servCatgCount,
              servCatgHourOrginCost: form.getFieldValue(
                'servCatgHourOrginCost',
              ),
              servCatgOrginTotalAmount,
              servCatgDiscTotalAmount,
            },
            editModalData?.proServCatgId ? pirceChange : null,
          ),
        });
      }
    }
  };

  const conutChange = (_val, target) => {
    const { form } = modalRef.current;
    let servCatgCount = form.getFieldValue('servCatgCount'); // 数量

    // 如果优惠后总价是禁用的，或者是子级新增，则保持单价和优惠后单价不变，通过数量计算总价和优惠后总价
    if (
      ['servCatgUnitPrice', 'servCatgHourDiscCost', 'servCatgCount'].includes(
        target,
      )
    ) {
      setPriceAll(form);
    } else {
      // 总价
      let servCatgOrginTotalAmount = form.getFieldValue(
        'servCatgOrginTotalAmount',
      );
      // you
      let servCatgHourDiscCost = form.getFieldValue('servCatgHourDiscCost');
      // 优惠后总价说
      let servCatgDiscTotalAmount = form.getFieldValue(
        'servCatgDiscTotalAmount',
      );
      if (target == 'servCatgDiscTotalAmount') {
        servCatgHourDiscCost = +(
          servCatgDiscTotalAmount / servCatgCount
        ).toFixed(2);
      }
      form.setFieldsValue({
        ...getPrice(
          {
            servCatgCount,
            servCatgOrginTotalAmount,
            servCatgHourOrginCost: form.getFieldValue('servCatgHourOrginCost'),
            servCatgDiscTotalAmount,
          },
          editModalData?.proServCatgId ? pirceChange : null,
        ),
        servCatgHourDiscCost,
      });
    }
  };

  const selectTeamChange = (id, item) => {
    console.log('selectTeamChange.....', id, item);
    let projectId = history.location.query?.projectId;
    if (projectId && editModalData?.proServCatgId) {
      const { form } = modalRef.current;
      let oldArr = form.getFieldsValue()?.addTeamMemberList || [];
      let filteredArr = oldArr.filter((item) => item.value !== id);
      form.setFieldsValue({
        addTeamMemberList: [...filteredArr],
      });
      //   dispatch({
      //     type: 'project/addTeamRule',
      //     payload: {
      //       projectId,
      //       proServCatgId: editModalData.proServCatgId,
      //       teamMemberId: id.split('-')[1],
      //     },
      //   }).then((res) => {
      //     if (!res) {
      //       message.warn('该成员存在上报信息！');

      //     }
      //   });
    }
  };

  const leaderChange = (keys, value) => {
    // console.log("keys=",keys,"value=",value)
    const { form } = modalRef.current;
    // console.log("form=",form)
    let oldArr = form.getFieldsValue()?.addTeamMemberList || [];
    // console.log("oldArr=",oldArr)
    let lastLeaderIndex = oldArr.findIndex((item) => item == leaderKey);
    if (lastLeaderIndex != -1) oldArr.splice(lastLeaderIndex, 1);
    setLeaderKey(keys);
    oldArr.push(value);
    // oldArr = [...new Set(oldArr)];
    oldArr = Array.from(new Set(oldArr.map(JSON.stringify))).map(JSON.parse);
    // console.log("oldArr1=",oldArr)
    form.setFieldsValue({
      addTeamMemberList: oldArr,
    });
  };

  function range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  const residueMoney = useMemo(() => {
    let listCount = dataList.reduce(
      (pre, item) => pre + item.servCatgDiscTotalAmount,
      0,
    );
    return +((rowData?.projectAmount || 0) / 100).toFixed(2) - listCount;
  }, [dataList]);

  const rowSelection = {
    selectedRowKeys: selectKey,
    onChange: (userIdList) => {
      console.log('任务列表', userIdList);

      setSelectKey(userIdList);
    },
  };

  const taskListcolumns = [
    {
      title: '任务名称',
      dataIndex: 'taskName',
      key: 'taskName',
      width: '10%',
    },
    {
      title: '负责人',
      dataIndex: 'taskManagerName',
      key: 'taskManagerName',
      width: '10%',
    },
    {
      title: '参与人员',
      dataIndex: 'dbTaskTeamMemberListStr',
      key: 'dbTaskTeamMemberListStr',
      // render: (text, record) => {
      //   return (
      //     <div>
      //       {statusObj[record?.projectStatus]}
      //     </div >
      //   )
      // }
    },
    {
      title: '任务时间',
      dataIndex: 'taskBeginTime',
      key: 'taskBeginTime',
      render: (data, record) => {
        console.log('任务时间', data, record);
        return (
          <div>
            {moment(record?.taskBeginTime).format('YYYY.MM.DD') +
              ' ~ ' +
              moment(record?.taskEndTime).format('YYYY.MM.DD')}
          </div>
        );
      },
    },
    {
      title: '任务状态',
      dataIndex: 'taskStatus',
      key: 'taskStatus',
      width: '8%',
      render: (text, record) => {
        return <div>{statusObj[record?.taskStatus]}</div>;
      },
    },
    {
      title: '任务工期',
      dataIndex: 'taskWorkPeriod',
      key: 'taskWorkPeriod',
      width: '8%',
    },
    {
      title: '任务已上报/时',
      dataIndex: 'rptWorkHour',
      key: 'rptWorkHour',
      width: '10%',
    },
    {
      title: '任务备注',
      dataIndex: 'taskRemark',
      key: 'taskRemark',
      width: '10%',
    },
  ];
  console.log('editModalData?.servCatgCode', editModalData?.servCatgCode);

  const edtaFormItem = [
    isSplitProworkPkgModal && {
      label: '拆分类型',
      name: 'splitType',
      type: 'RadioGroup',
      props: {
        options: [
          { label: '拆分未完成数量', value: 0 },
          { label: '拆分已完成数量', value: 1 },
        ],
        onChange: (e) => {
          console.log('e.target.value', e.target.value);
          setselectedSplitType(e.target.value);
        },
      },
    },
    isSplitProworkPkgModal && {
      label: '拆分方向',
      name: 'splitDirect',
      type: 'RadioGroup',
      props: {
        options:
          editModalData?.servCatgCode?.split('.').length >= 3
            ? [{ label: '水平拆分', value: 1 }]
            : [
                { label: '向下拆分', value: 0 },
                { label: '水平拆分', value: 1 },
              ],
        onChange: (e) => {
          console.log('e.target.value', e.target.value);
          setselectedSplitType(e.target.value);
        },
      },
    },
    {
      label: '选择服务类目',
      name: 'servCatgId',
      type: 'TreeSelect',
      required: '请选择服务类目',
      props: {
        placeholder: '请选择服务类目',
        treeDefaultExpandAll: true,
        fieldNames: {
          label: 'servCatgName',
          value: 'servCatgId',
          children: 'child',
        },
        // options: project.servcatgEasyList.map((item) => ({
        treeData: [project.servcatgList],
        onChange: setFormValueChange,
        disabled: editModalData?.servCatgStatus == 1 || isSplitProworkPkgModal,
      },
    },
    {
      label: '工作包别名',
      name: 'servCatgName',
      required: '工作包别名不能为空',
      type: 'Input',
      props: {
        placeholder: '请输入工作包别名',
        disabled: editModalData?.servCatgStatus == 1 && !isSplitProworkPkgModal,
      },
    },
    {
      label: '工时费',
      name: 'servCatgHourOrginCost',
      type: 'InputNumber',
      props: {
        placeholder: '请输入工时费',
        stepType: 'inside',
        onChange: debounce(
          (val) => conutChange(val, 'servCatgHourOrginCost'),
          300,
        ),
        style: { width: '100%' },
        min: 0,
        disabled:
          (!!editModalData && !editModalData?.$childrenAdd) ||
          isSplitProworkPkgModal,
      },
    },
    {
      label: '选择责任人',
      name: 'servCatgLeader',
      type: 'Select',
      props: {
        placeholder: '请选择责任人',
        options: systemOrgani.employeeAll,
        onChange: leaderChange,
        disabled: editModalData?.servCatgStatus == 1 || isSplitProworkPkgModal,
      },
    },
    {
      label: '选择参与团队',
      name: 'addTeamMemberList',
      type: 'Select',
      props: {
        placeholder: '请选择参与团队',
        mode: 'multiple',
        allowClear: true,
        maxTagCount: 'responsive',
        options: systemOrgani.employeeAll,
        onDeselect: selectTeamChange, //删除不能调接口，只能添加
        // onChange: leaderChange,
        disabled: editModalData?.servCatgStatus == 1 && !isSplitProworkPkgModal,
      },
    },

    {
      label: '所用工期/天（工时数）',
      name: 'servCatgWorkPeriod',
      type: 'Input',
      props: {
        placeholder: '请输入所用工期',
        // disabled: true,
        style: { width: '100%' },
        disabled: editModalData?.servCatgStatus == 1 || isSplitProworkPkgModal,
      },
    },
    {
      label: isSplitProworkPkgModal ? '拆分数量' : '数量',
      name: 'servCatgCount',
      render: () => {
        const isRoot =
          !editModalData?.servCatgCode.includes('.') ||
          editModalData?.childList?.length > 0;
        console.log('itemsss', editModalData);
        let disabledInp = !!editModalData;
        if (
          editModalData?.$childrenAdd ||
          editModalData?.childList == null ||
          editModalData?.childList?.length == 0
        ) {
          disabledInp = false;
        }
        if (editModalData?.servCatgCode.includes('.')) {
          // 子集编辑不允许输入
          disabledInp = true;
        }
        if (isSplitProworkPkgModal) {
          // 拆分可输入
          disabledInp = false;
        }
        return (
          <QuantityInputWrapper
            isRoot={isRoot}
            disabledInp={disabledInp}
            onChange={debounce((val) => conutChange(val, 'servCatgCount'), 300)}
            onOpenModal={() => setCountModalVisible(true)}
            placeholder="请输入数量"
          />
        );
      },
    },
    {
      name: 'subProServCatgCountList',
      type: 'Input',
      props: { style: { display: 'none' } },
      formItemProps: { style: { display: 'none' } },
    },
    {
      label: '单价',
      name: 'servCatgUnitPrice',
      type: 'Input',
      props: {
        disabled: true,
        placeholder: '单价',
      },
    },
    {
      label: '优惠后单价',
      name: 'servCatgHourDiscCost',
      type: 'Input',
      props: {
        disabled: true,
        placeholder: '优惠后单价',
      },
    },
    {
      label: '单位',
      name: 'servCatgUnit',
      type: 'Input',
      props: {
        placeholder: '请输入单位',
        disabled: editModalData?.servCatgStatus == 1 || isSplitProworkPkgModal,
      },
    },
    {
      label: '总价',
      name: 'servCatgOrginTotalAmount',
      type: 'InputNumber',
      props: {
        placeholder: '请输入总价',
        stepType: 'inside',
        onChange: debounce(
          (val) => conutChange(val, 'servCatgOrginTotalAmount'),
          300,
        ),
        style: { width: '100%' },
        min: 0,
        disabled: editModalData?.servCatgCode.includes('.'),
        //   (!!editModalData && !editModalData?.$childrenAdd) ||
        //   editModalData?.$childrenAdd ||
        //   isSplitProworkPkgModal,
      },
    },
    {
      label: '优惠后总价',
      name: 'servCatgDiscTotalAmount',
      type: 'InputNumber',
      help: `项目剩余金额：${residueMoney}`,
      props: {
        placeholder: '请输入优惠后总价',
        stepType: 'inside',
        onChange: debounce(
          (val) => conutChange(val, 'servCatgDiscTotalAmount'),
          300,
        ),
        style: { width: '100%' },
        min: 0,
        disabled: editModalData?.servCatgCode.includes('.'),
        // disabled:
        //   (!!editModalData && !editModalData?.$childrenAdd) ||
        //   editModalData?.$childrenAdd ||
        //   isSplitProworkPkgModal,
      },
    },
    {
      label: '优惠折扣',
      name: 'servCatgHourDisc',
      type: 'Input',
      props: {
        disabled: true,
        placeholder: '优惠折扣',
      },
    },
    {
      label: '总优惠金额',
      name: 'DiscountAmount',
      type: 'Input',
      props: {
        disabled: true,
        placeholder: '总优惠金额',
      },
    },
    {
      label: '工作包周期',
      name: 'servCatgTime',
      type: 'DatePickerRangePicker',
      props: {
        // onChange: timeChange,
        showTime: {
          hideDisabledOptions: true, //不显示禁用的时间
          defaultValue: [moment('09:00:00', 'HH:mm'), moment('18:00', 'HH:mm')],
          minuteStep: 30,
          format: 'HH:mm',
        },
        disabledTime: (_, type, b) => ({
          disabledHours: () => {
            let arr = range(0, 24);
            arr.splice(9, 10);
            if (type == 'start') arr = arr.concat([12, 18]);
            if (type == 'end') arr = arr.concat([13, 9]);
            return arr;
          },
          disabledMinutes: (hours) => {
            if (hours == 12) return [30];
            if (hours == 13) return [0];
            return [];
          },
        }),
        disabled: editModalData?.servCatgStatus == 1 && !isSplitProworkPkgModal,
      },
    },
    // {
    //   label: '服务类目金额',
    //   render: () => <div>{countMoney}</div>,
    // },
    {
      label: '预估外包费用',
      name: 'servCatgEstimatedOsAmount',
      type: 'Input',
      props: {
        placeholder: '预估外包费用',
      },
    },
    {
      label: '实际外包费用',
      name: 'servCatgActualOsAmount',
      type: 'Input',
      props: {
        placeholder: '实际外包费用',
      },
    },
    {
      label: '功能详情描述',
      name: 'servCatgRemark',
      type: 'TextArea',
      formItemProps: {
        className: 'block-item',
      },
      props: {
        placeholder: '请输入功能详情描述',
        disabled: editModalData?.servCatgStatus == 1 && !isSplitProworkPkgModal,
      },
    },

    isSplitProworkPkgModal &&
      editModalData?.proServCatgId && {
        full: true,
        name: '',
        label: '',
        formItemProps: {
          className: 'full-block-item',
        },
        render: (props, item) => {
          console.log('editModalData...', editModalData);

          return (
            <div className="12m3op12n3opn12o3n1o23">
              <TablePro
                request="project/getfulltasklist"
                rowKey={'taskId'}
                columns={taskListcolumns}
                curColumns
                // searchCloumns={searchCloumns}
                dataSource={project.fulltasklist}
                data={project.getfulltasklist}
                // extra={extra}
                columnsOptions={false}
                params={{
                  proServCatgId: editModalData?.proServCatgId,
                }}
                rowSelection={{
                  type: 'checkbox',
                  ...rowSelection,
                }}
              />
            </div>
          );
        },
      },
  ].filter(Boolean);

  const beforeDel = async (row) => {
    if (!row.projectId) {
      return true;
    }
    let shouldDel = true;
    if (row.proServCatgId) {
      await dispatch({
        type: 'project/delServcatgRule',
        payload: {
          proServCatgId: row.proServCatgId,
          projectId: row.projectId,
        },
      }).then((res) => {
        shouldDel = res;
        if (!res) {
          message.warn('该服务类目存在上报信息，不可删除！');
        }
      });
    }
    return shouldDel;
  };

  const deleteItem = async (row) => {
    await onDelete?.(row);
    let list = [...dataList];
    let i = list.findIndex((item) => item.key == row.key);
    dataList.splice(i, 1);
    // 删除之后通过重新排序设置code跟排序
    onSort?.(sortToArrData([...dataList]));
  };
  const copyItem = (data) => {
    if (data.$top) {
      return editChange({
        ...data,
        dbServCatgTeamMemberList: [],
      });
    }
    // code 生成
    let servCatgCodeArr = data.servCatgCode?.split('.') || [];
    let parent = dataListFind(dataList, data.key, true);
    servCatgCodeArr.splice(
      servCatgCodeArr.length - 1,
      1,
      parent?.childList?.length + 1,
    );
    let servCatgCode = servCatgCodeArr.join('.');
    let payload = {
      ...data,
      proServCatgId: undefined,
      childList: undefined,
      servCatgAlias: undefined,
      servCatgLeaderName: undefined,
      servCatgFinishNum: undefined,
      servCatgDbcode: undefined,
      dbServCatgList: undefined,
    };
    onSave?.(payload, {
      servCatgCode,
      servCatgSort: parent?.childList?.length + 1,
      proServCatgPantId: data.proServCatgPantId,
    });
  };

  const editItem = (row, isSplitProworkPkgModal = false) => {
    const { form } = modalRef.current;
    if (row.servCatgTime) {
      row.servCatgTime[0] = moment(row.servCatgTime[0]);
      row.servCatgTime[1] = moment(row.servCatgTime[1]);
    }

    setIsSplitProworkPkgModal(false);
    setEditModalVisible(true);
    setLeaderKey(row.taskLeader);
    setEditModalData({
      ...row,
      ...getPrice(row),
    });
    form.setFieldsValue({
      ...row,
      ...getPrice(row),
    });
  };

  const addItemToChildren = (row) => {
    isAddStatus.current = true;
    setEditModalVisible(true);
    setIsSplitProworkPkgModal(false);
    const { form } = modalRef.current;

    // Create a new object excluding the id to treat it as a new addition
    const { proServCatgId, ...restRow } = row;

    // Calculate price related fields if needed
    const priceData = getPrice(row);

    const newData = {
      ...restRow,
      ...priceData,
      $childrenAdd: true,
      maxCount: row.servCatgCount, // Limit count to parent's count
    };

    setEditModalData(newData);

    // Pre-fill the form with the parent's data (excluding id)
    if (form) {
      if (newData.servCatgTime) {
        newData.servCatgTime[0] = moment(newData.servCatgTime[0]);
        newData.servCatgTime[1] = moment(newData.servCatgTime[1]);
      }
      form.setFieldsValue(newData);
    }
  };

  const splitItemToChildren = (row, isChildLevel = false) => {
    isAddStatus.current = false;
    const { form } = modalRef.current;
    if (row.servCatgTime) {
      row.servCatgTime[0] = moment(row.servCatgTime[0]);
      row.servCatgTime[1] = moment(row.servCatgTime[1]);
    }

    setIsSplitProworkPkgModal(true);
    setEditModalVisible(true);
    setLeaderKey(row.taskLeader);

    setEditModalData({
      ...row,
      ...getPrice(row),
      $childrenAdd: true,
    });

    setOldServCatgCount(row.servCatgCount);

    console.log(
      'selectedSplitType...addItemToChildren',
      row.servCatgCount,
      row.servCatgFinishNum,
    );

    //未完成工作包
    let incompleteCount = row.servCatgCount - row.servCatgFinishNum;

    form.setFieldsValue({
      ...row,
      splitType: 0,
      splitDirect: row.servCatgCode?.split('.').length >= 3 ? 1 : 0,
      servCatgCount: incompleteCount >= 0 ? incompleteCount : row.servCatgCount,
      ...getPrice(row),
    });
  };

  const sortChange = (from, to) => {
    let list = [...dataList];
    if (from.key != to.key) {
      let targetIndex = list.findIndex((item) => item.key == from.key);
      let target = list.splice(targetIndex, 1)?.[0];
      if (target) {
        let dropIndex = list.findIndex((item) => item.key == to.key);
        let index = targetIndex > dropIndex ? 0 : 1;
        list.splice(dropIndex + index, 0, target);
      }
    }
    let res = sortToArrData(list);
    if (res.length > 1) {
      onSort?.(res);
    }
    // resList = [...list];
    // return [...list];
    // onChange?.(resList);
  };

  console.log('dataList...', dataList);

  return (
    <div className="ServCategoryList">
      {dataList.map((item, index) => {
        let calHeaderl = (
          <Row className="detail-box">
            <Col span={2}>
              <span className="c999">
                {item.servCatgCode} {item.servCatgName}
              </span>
            </Col>
            <Col span={2}>
              责任人：
              {systemOrgani.employeeAll && (
                <span className="c999">
                  {
                    findTree(systemOrgani.employeeAll, item.servCatgLeader)
                      ?.label
                  }
                </span>
              )}
            </Col>
            <Col span={2}>
              <Typography.Paragraph ellipsis>
                参与制作：
                <span className="c999">
                  {item.addTeamMemberList
                    ?.map((id) => findTree(systemOrgani.employeeAll, id)?.label)
                    .join(',')}
                </span>
              </Typography.Paragraph>
            </Col>
            <Col span={2}>
              单价：
              {item.servCatgHourDiscCost}
            </Col>
            <Col span={2}>
              已完成：
              {item.servCatgFinishNum} / {item.servCatgCount}
            </Col>
            <Col span={2}>
              总金额：
              {item.servCatgDiscTotalAmount}
            </Col>
            <Col span={2}>
              完成金额：
              {item.servCatgFinishNum == item.servCatgCount
                ? item.servCatgDiscTotalAmount
                : +(item.servCatgFinishNum * item.servCatgHourDiscCost).toFixed(
                    2,
                  )}
            </Col>
            <Col span={2}>
              未完成金额：
              {
                +(
                  (item.servCatgCount - item.servCatgFinishNum) *
                  item.servCatgHourDiscCost
                ).toFixed(2)
              }
            </Col>
            <Col span={2}>
              状态：
              {item.servCatgStatus == 1 ? (
                <Tag.MiniTag type="success">已关闭</Tag.MiniTag>
              ) : (
                <Tag.MiniTag>未关闭</Tag.MiniTag>
              )}
            </Col>
          </Row>
        );
        return (
          <SortBox data={item} onChange={sortChange} key={item.key}>
            <ItemDetail
              isSplitProworkPkg={isSplitProworkPkg}
              disabled={disabled}
              headerExtra={headerExtra}
              extra={extra}
              data={item}
              headerEl={calHeaderl}
              addItem={addItemToChildren}
              splitItem={splitItemToChildren}
              hideMore={item.childList?.length > 0}
              deleteItem={deleteItem}
              beforeDel={beforeDel}
              editItem={editItem}
              copyItem={copyItem}
              onChange={onChange}
              employeeAll={systemOrgani.employeeAll}
              servcatgEasyList={project.servcatgEasyList}
              key={item.key}
              setDataList={setDataList}
              onCancel={() =>
                setDataList((pre) => {
                  pre.splice(index, 1);
                  // onChange?.(pre);
                  return [...pre];
                })
              }
            />
          </SortBox>
        );
      })}
      <ModalFormPro
        visible={editModalVisible}
        edtaFormItem={edtaFormItem}
        width={'80%'}
        formProps={{
          layout: 'vertical',
          labelCol: { span: 8 },
          wrapperCol: { span: 12 },
          className: isSplitProworkPkgModal ? 'inline-form-20' : 'inline-form',
          initialValues: {
            // servCatgHourOrginCost: 1800,
          },
        }}
        ref={modalRef}
        btnLoading={loading['project/updataServcat']}
        onSave={editChange}
        onCancel={() => {
          setEditModalVisible(false);
          setEditModalData(null);
        }}
      />
      <ModifyCountModal
        visible={countModalVisible}
        onCancel={() => setCountModalVisible(false)}
        onOk={handleCountModalOk}
        data={editModalData}
      />
      {!disabled && (
        <div className="dashedBtn" onClick={addItem}>
          + 添加
        </div>
      )}
    </div>
  );
};

export default connect(({ systemOrgani, project, loading }) => ({
  systemOrgani,
  project,
  loading: loading.effects,
}))(ServCategoryList);
